<section
  class="sec-events-filter filter-wrapper"
  [ngClass]="{ hidden: !active }"
  [class.active]="active"
  (keyup.escape)="hide()"
>
  <form>
    <div class="top-items">
      <span class="filter-by-text">FILTER BY</span>
      <button
        type="reset"
        class="clear-all-button"
        (click)="itemClicked('clearAll')"
      >
        CLEAR ALL
      </button>
    </div>
    <div class="checkboxes">
      <div class="checkbox-row">
        <mat-checkbox
          type="checkbox"
          class="filter-checkbox"
          [color]="'primary'"
          [checked]="selectedFilters.has(secEventType.Audio)"
          (click)="itemClicked(secEventType.Audio)"
          >Audio</mat-checkbox
        >
      </div>
      <div class="checkbox-row">
        <mat-checkbox
          type="checkbox"
          class="filter-checkbox"
          [color]="'primary'"
          [checked]="selectedFilters.has(secEventType.Subtitles)"
          (click)="itemClicked(secEventType.Subtitles)"
          >Subtitles</mat-checkbox
        >
      </div>
      <div class="checkbox-row">
        <mat-checkbox
          type="checkbox"
          class="filter-checkbox"
          [color]="'primary'"
          [checked]="selectedFilters.has(secEventType.ClosedCaptions)"
          (click)="itemClicked(secEventType.ClosedCaptions)"
          >Closed Captions</mat-checkbox
        >
      </div>
      <div class="checkbox-row">
        <mat-checkbox
          type="checkbox"
          class="filter-checkbox"
          [color]="'primary'"
          [checked]="selectedFilters.has(secEventType.Autopilot)"
          (click)="itemClicked(secEventType.Autopilot)"
          >Autopilot</mat-checkbox
        >
      </div>
      <div class="checkbox-row">
        <mat-checkbox
          type="checkbox"
          class="filter-checkbox"
          [color]="'primary'"
          [checked]="selectedFilters.has(secEventType.Graphics)"
          (click)="itemClicked(secEventType.Graphics)"
          >Graphics</mat-checkbox
        >
      </div>
      <!-- Remove comment before releasing P2 -->
      <!--            <div class="checkbox-row">-->
      <!--                <mat-checkbox type="checkbox" class="filter-checkbox" [color]="'primary'" [checked]="selectedFilters.has(secEventType.Cuetone)" (click)="itemClicked(secEventType.Cuetone)">-->
      <!--                <span class="checkbox-text">Cuetone</span>-->
      <!--            </div>-->
      <div class="checkbox-row">
        <mat-checkbox
          type="checkbox"
          class="filter-checkbox"
          [color]="'primary'"
          [checked]="selectedFilters.has(secEventType.FloatingMedia)"
          (click)="itemClicked(secEventType.FloatingMedia)"
          >Floating Media</mat-checkbox
        >
      </div>
      <div class="checkbox-row">
        <mat-checkbox
          type="checkbox"
          class="filter-checkbox"
          [color]="'primary'"
          [checked]="selectedFilters.has(secEventType.SCTE)"
          (click)="itemClicked(secEventType.SCTE)"
          >SCTE</mat-checkbox
        >
      </div>
    </div>
  </form>
</section>
